import customDayTemplatesModel from '$$customDayTemplatesModel';
import customDaysModel from '$$customDaysModel';

export default function (instance, ganttData) {
  instance.ganttDataApi.getCustomDaysForProject = projectId => {
    if (!ganttData) {
      return customDayTemplatesModel.serialize().find(data => +data.ganttId === +projectId)?.customDays;
    }

    return ganttData.customDays;
  };

  instance.ganttDataApi.setAndGetCustomDaysForProject = projectId => {
    if (!ganttData) {
      return customDayTemplatesModel.setAndGetCustomDaysForProject(projectId);
    }

    return ganttData.customDays ? customDaysModel.getSortingDaysByActiveProject(projectId, ganttData.customDays) : null;
  };
}
